module.exports = __webpack_public_path__ + "img/east-bound.212e15dd.svg";